import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Printer, Package, History, Menu, X, LogOut } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

const navItems = [
  { path: "/", icon: LayoutDashboard, label: "DASHBOARD" },
  { path: "/create", icon: Printer, label: "CREATE LABEL" },
  { path: "/products", icon: Package, label: "PRODUCTS" },
  { path: "/history", icon: History, label: "HISTORY" },
];

export const Sidebar = ({ onLogout }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Mobile hamburger */}
      <Button
        data-testid="mobile-menu-btn"
        variant="ghost"
        onClick={() => setMobileOpen(true)}
        className="fixed top-3 left-3 z-50 lg:hidden h-12 w-12 bg-card border border-border/50 rounded-sm"
      >
        <Menu className="w-6 h-6" />
      </Button>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        data-testid="sidebar-nav"
        className={cn(
          "fixed left-0 top-0 h-screen bg-card border-r border-border/50 flex flex-col z-50 transition-transform duration-200",
          "w-[240px]",
          "lg:translate-x-0",
          mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        )}
      >
        <div className="p-4 lg:px-6 lg:py-5 border-b border-border/50 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary rounded-sm flex items-center justify-center shrink-0">
              <span className="text-primary-foreground font-bold text-lg font-mono">M</span>
            </div>
            <div>
              <h1 className="text-lg font-bold tracking-wider uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                MeatPrint
              </h1>
              <p className="text-[10px] text-muted-foreground tracking-widest uppercase">LABEL SYSTEM</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setMobileOpen(false)}
            className="lg:hidden h-8 w-8"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>

        <nav className="flex-1 py-4 flex flex-col gap-1 px-3">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 px-3 py-3 rounded-sm transition-all duration-150 group",
                  "hover:bg-secondary/80",
                  isActive
                    ? "bg-primary/10 text-primary border border-primary/20"
                    : "text-muted-foreground border border-transparent"
                )
              }
            >
              <item.icon className="w-5 h-5 shrink-0" strokeWidth={2} />
              <span
                className="text-xs font-bold tracking-wider uppercase"
                style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              >
                {item.label}
              </span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-border/50 space-y-2">
          <Button
            data-testid="logout-btn"
            variant="ghost"
            onClick={onLogout}
            className="w-full flex items-center gap-3 px-3 py-3 text-muted-foreground hover:text-destructive rounded-sm text-xs font-bold tracking-wider uppercase"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            <LogOut className="w-4 h-4" />
            <span>LOGOUT</span>
          </Button>
          <div className="text-[10px] text-muted-foreground/50 tracking-wider uppercase text-center">
            V1.2 INDUSTRIAL
          </div>
        </div>
      </aside>
    </>
  );
};
